import { render } from "./SidebarSubtitle.vue?vue&type=template&id=3d7cc956&scoped=true&ts=true"
import script from "./SidebarSubtitle.vue?vue&type=script&lang=ts"
export * from "./SidebarSubtitle.vue?vue&type=script&lang=ts"

import "./SidebarSubtitle.vue?vue&type=style&index=0&id=3d7cc956&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d7cc956"]])

export default __exports__